import PortalIdParser from 'PortalIdParser';
import { useSubscribeToCopilotChannel } from 'copilot-toolkit/channel/hooks/useSubscribeToCopilotChannel';
import enviro from 'enviro';
import { getFullUrl } from 'hubspot-url-utils';
import { useCallback, useContext, useState } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import memoizeOne from 'react-utils/memoizeOne';
import { useHostAppName } from './hooks/useHostAppName';
import { CopilotChannelContext } from 'copilot-toolkit/channel/CopilotChannelContext';

// @ts-expect-error Not Typed
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import { jsx as _jsx } from "react/jsx-runtime";
const getUrl = memoizeOne((hostAppName, instanceId) => {
  const env = enviro.deployed() ? 'app' : 'local';
  let url = `${getFullUrl(env)}/chatspot-message-modal-ui/${PortalIdParser.get()}?hostAppName=${hostAppName}&variant=uiiframe`;
  if (instanceId) {
    url += `&instanceId=${instanceId}`;
  }
  return url;
});
const CopilotFullscreenModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const hostAppName = useHostAppName();
  // Optional: reads instanceId from context if CopilotChannelProvider exists in parent tree
  // Falls back to undefined if provider is missing, which gracefully omits instanceId from URL
  const contextValue = useContext(CopilotChannelContext);
  const instanceId = contextValue === null || contextValue === void 0 ? void 0 : contextValue.instanceId;
  const closeModal = useCallback(() => {
    setIsVisible(false);
  }, []);
  const showModal = useCallback(() => {
    setIsVisible(true);
  }, []);
  useSubscribeToCopilotChannel('OPEN_FULLSCREEN_MESSAGE_VIEWER', showModal);
  useSubscribeToCopilotChannel('OPEN_FULLSCREEN_MESSAGE_VIEWER_V2', showModal);
  useSubscribeToCopilotChannel('OPEN_ACTION_FORM', showModal);
  return /*#__PURE__*/_jsx(ModalIFrame, {
    appName: "chatspot-message-modal-ui",
    height: "600",
    initTimeout: 20000,
    name: "chatspot-message-modal",
    onClose: closeModal,
    onMessage: emptyFunction,
    onReady: emptyFunction,
    preload: true,
    show: isVisible,
    showLoadingIndicator: true,
    src: getUrl(hostAppName, instanceId),
    width: "1000"
  });
};
export default CopilotFullscreenModal;